import { render, staticRenderFns } from "./FooterMobileMenu.vue?vue&type=template&id=9c3c6016&scoped=true&"
import script from "./FooterMobileMenu.vue?vue&type=script&lang=js&"
export * from "./FooterMobileMenu.vue?vue&type=script&lang=js&"
import style0 from "./FooterMobileMenu.vue?vue&type=style&index=0&id=9c3c6016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3c6016",
  null
  
)

export default component.exports